export const FinnishLabel = {
    Enter_the_following_information_to_enter: "Enter the following information to enter",
    login: "login",
    Username: "Username",
    password: "Password",
    Orders: "Orders",
    Online: "Online",
    Offline: "Offline",
    Info: "Info",
    email: "Email",
    vehicletypes: "servicetypes",
    loginstatus: "login status",
    lastonlinetime: "last online time",
    fetchingdata: "Receiving information...",
    poperLoading: "please wait",
    Noinformationfound: "No information found",
    Drivers: "Drivers",
    otherdropoffs: "other dropoffs",
    paymentmethod: "Payment method",
    Receiver: "By Receiver",
    Sender: "By Sender",
    Balance: "Balance",
    Cash: "Cash",
    Wallet: "Wallet",
    Close: "Close",
    noVehicleType: "There is no service type to display",
    Fname: "First name",
    Lname: "Last name",
    Pnumber: "Phone number",
    driver: "Driver",
    pleaseSellectService: "Please Select Service Type",
    Pleasetryanotherkeyword: "Please try another keyword",
    DropOff: "Drop off",
    Noaddressavailable: "No address available",
    Managefavoriteaddresses: "Manage addresses",
    address: "Address",
    Saved: "Saved",
    block: "Block",
    Floor: "Floor",
    Unit: "Unit",
    notesfordriver: "Notes for driver",
    Price: "Price",
    EditOrder: "Edit order",
    Firstname: "First name",
    Lastname: "Last name",
    Phonenumber: "Phone number",
    Search: "Search",
    Service: "Service",
    Passenger: "Customer",
    Pickup: "Pickup",
    Pricedetails: "Price details",
    Fee: "Fee",
    Fornow: "For now",
    now:"Nyt",
    Scheduled: "Scheduled",
    before: "before :",
    Settime: "Set time",
    after: "after :",
    confirm: "Confirm",
    Cancel: "Cancel",
    Addresses: "Addresses",
    Savedaddresses: "Saved addresses",
    new: "New",
    Editaddress: "Edit address",
    Saveaddress: "Save address",
    Language: "Language",
    en: "English",
    fa: "Persian",
    English: "English",
    Persian: "Persian",
    Logout: "Log out",
    logotTitle: "Log out from account?",
    logoutDescription: "You will be logged out from account and you should login later",
    confirmLogout: "Yes, log out",
    skipLogout: "Cancel",
    ascending: "Ascending",
    descending: "Descending",
    "sort[createdAt]": "Date",
    "sort[pickupScheduleDate]": "Pickup Schedule Time ",
    "sort[statusUpdatedAt]": "Sort by update at",
    SelectDateRange: "Date Range",
    StartDate: "Start Date",
    EndDate: "End Date",
    Today: "Today",
    Yesterday: "Yesterday",
    ThisWeek: "This Week",
    LastWeek: "Last Week",
    Last7Days: "Last 7 Days",
    ThisMonth: "This Month",
    LastMonth: "Last Month",
    Last3Month:"Viimeinen 3 kuukautta",
    monitoring: "Monitoring",
    Haveorder: "Have order",
    Estimated: "Estimated",
    ReceiverCash: "Maksa vastaanotin",
    SenderCash: "Cash ",
    SenderWallet: "Wallet",
    Auto: "Auto",
    Manual: "Manual",
    SendOrderr: "Send Order",
    Neworder: "New order",
    Person: "Individual",
    Business: "business",
    Businessname: "Business name",
    phonenumber: "Phone number",
    Adddropoff: "Add drop off",
    AllKey: "All",
    MeKey: "Me",
    Vehicletype: "Vehicle type",
    status: "Status",
    statusInProgress: "In Progress",
    statusCanceled: "Canceled",
    statusPending: "Pending",
    statusUnassigned: "Unassigned",
    statusDone: "Done",
    dispatcher: "operator",
    customer: "mobile",
    regexcode: "Code",
    regexcustomerPhone: "Customer Phone",
    regexcustomerName: "Customer Name",
    regexdriverPhone: "Driver Phone",
    regexdriverName: "Driver Name",
    regexdriverUsername: "Driver Username",
    pickupDescription: "pickup Description",
    Pickupnote:"Pikakuvite",
    filter: "Filter",
    clear: "Clear",
    orderInfoError: "Error receiving information",
    Details: "Details",
    History: "History",
    Phone: "Phone",
    km: "km",
    Espath: "Es. path",
    Receipt: "Receipt",
    Copylink: "Copy link",
    repeatOrder: "Repeat Order",
    Shipmentlabel:"Shipment label",
    Edit: "Edit",
    EditPrice: "Price & Earning",
    EditPrice2: "Price",
    EditEarning: "Earning",
    Endtrip: "End order",
    Canceltravel: "Cancel Order",
    CancellText: "After cancellation, the order is canceled for the driver",
    confirmCancel: "Yes",
    Endtravel: "complete",
    EndlText: "Upon completion, the order for the Customer and driver is successfully completed and the amount is deducted from the Customer account",
    confirmEnd: "Yes",
    End: "Cancel Order",
    Deliveredat: "Delivered at ",
    pod: "Proof of delivery",
    pop:"Proof of pickup",
    Notes: "Notes",
    Nonotes: "No notes",
    Photo: "Photo",
    Signature: "Signature",
    Nosignature: "No signature",
    Nophoto: "No photo",
    Pending: "Pending",
    Unassigned: "Unassigned",
    Assigned: "In Progress",
    PickedUp: "In Progress",
    Started: "In Progress",
    Done: "Done",
    CustomerCanceled: "Canceled",
    DriverCanceled: "Canceled",
    SupportCanceled: "Canceled",
    Arrived: "In Progress",
    Createdsuccessfully: "Created successfully",
    Estime: "Es. time",
    Promocode: "Promo code",
    Updatedsuccessfully: "Updated successfully",
    statusCustomerCanceled: "Customer Canceled",
    statusAssigned: "Assigned",
    statusStarted: "Started",
    "statusPickedUp": "Poimittu",
    statusDriverCanceled: "Driver Canceled",
    statusArrived: "Arrived",
    statusSupportCanceled: "Support Canceled",
    Title: "Title",
    ContactFullname: "Contact Full name",
    Contactphonenumber: "Contact phone number",
    Commission: "Commission",
    surcharge: "Surcharge",
    haslogined: "has logged in",
    Notloggedin: "Not logged in",
    Schedule: "Schedule",
    Date: "Date",
    Time: "Time",
    noDateToShow: "There is no Date to display",
    noTimeToShow: "There is no Time to display",
    Apply: "Apply",
    lowBalance: "low balance",
    balanceError: " balance must be at least equal to order price",
    Methods: "Methods",
    Addressbook: "Address book",
    AddressbookSearchbar: "Search by address, title and ID",
    AddressbookDropOf: "Address book (Drop off)",
    AddressbookPickup: "Address book (Pickup)",
    hide: "Hide",
    Nosavedaddress: "No saved address",



    Romanian: "romanian",
    business: "business",
    username: "User Name",
    rememberme: "remember me",
    SendOrder: "Send Order",
    code: "Code",
    noorder: "noOrder",
    pleaseSellectParsel: "Please Select Service",
    Order: "Order",
    Code: "Code",
    Editorder: "Edit Order",
    all: "All",
    Address: "Address",
    "Block/Building": "Block/Building",
    Pickedupat: "Picked up at ",
    for: "For",
    fr: "French",
    AllVehicletypes: "All Service types",
    AllServices: "All Services",
    French: "French",
    enterDataCorrectly: "Enter information correctly.",
    controlThatbeforeLoweEqualAfter: `Time "Before :" cannot be less than "After :" `,
    ForceAssign: "Force Assign",
    Allvehicletypes: "All vehicle types",
    waitforconfirm: "xxx ( Wait for confirm )",
    waitforconfirm2: "Wait for confirm",
    Dispatching: "Dispatching",
    NoDriver: "No Driver",
    OtherDetails: "Other Details",
    StatusandDriver: "Status & Driver",
    EditStatusandDriver: "Edit Status and Driver",
    Current: "Current",

    EDAS_Pending: "Pending",
    EDAS_Assigned: "Assigned",
    EDAS_PickedUp: "PickedUp",
    EDAS_Unassigned: "Unassigned",
    EDAS_Started: "Started",
    EDAS_Done: "Done",
    EDAS_CustomerCanceled: "Customer Canceled",
    EDAS_DriverCanceled: "Driver Canceled",
    EDAS_SupportCanceled: "Support Canceled",
    EDAS_Arrived: "Arrived",

    Pleasechooseadrivertochangestatus: "Please choose a driver to change status",
    icWarningEdit: "Changing Optinons may effects on price",
    Vehicletypewillbechanged: "Vehicle type will be changed",
    Yourcurrentvehicletypeanditwillbechangedandeffectsonprice: "Your current vehicle type will be changed and effects on price",
    Rejected: "Rejected",
    Rejected2: "(Rejected)",
    DriverVehicleTypeError: "There is no vehicle type for Driver",
    CodeNameFamilyPhonenumber: "Code, Name, Family, Phone number",
    youcanselectdriverintheedit: "You can select driver in the edit driver and status",


    Earning: "Earning",
    savePrice: "Save Price",
    saveEarning: "Save Earning",
    Total: "Total",
    Pricedetails: "Price details",
    "EditPickupDropOff": "Edit Addresses",

    noMoreData: "There is no more information",
    Dutch:"dutch",
    Ondemand: "On Demand",
    PD: "P & D",
    PD2: "P&D",
    PickupDropoff: "Pickup , Dropoff",
    PickupFlag: "P",
    DropOffFlag: "D",
    PickupandDelivery: "Pickup and Delivery",
    PickupDelivery: "Pickup and Delivery",
    Delivery: "Delivery",



    ServiceOptions: "Service Options",
    Searchbynameorphonenumber: "Search by name or phone number",
    Fullname: "Full name",
    type: "type",
    only: "xxx only",
    ChooseDriver: "Choose Driver",
    Events: "Events",
    Collecting: "Collecting",
    Transit: "Transit",
    Delivering: "Delivering",
    EDAS_Collecting: "Collecting",
    EDAS_Transit: "Transit",
    EDAS_Delivering: "Delivering",
    statusCollecting: "Collecting",
    statusTransit: "Transit",
    statusDelivering: "Delivering",
    status2: "status",
    Creator: "Creator",
    Creationdate: "Creation date",
    Orderid: "Order id",
    Pickup2: "Pickup",
    Dropoff2: "Dropoff",
    senderfullname: "Sender Name",
    block: "Block",
    senderphonenumber: "Sender number",
    Recieverfullname: "Receiver Name",
    Recieverphonenumber: "Receiver Number",
    PleaseSelect: "Please Select",
    CreateEvent: "Create Event",
    Description: "Description",
    detailsAboutEvent: "Details about event",
    CustomerVisibility: "Customer Visibility",
    LocationOnMap: "Location on map" ,


    event_Created:"Created",
    event_Unassigned:"Unassigned",
    event_Assigned:"Assigned",
    event_Started:"Started",
    event_Arrived:"Arrived",
    event_PickedUp:"PickedUp",
    event_OrderDone:"Order Done",
    event_DropoffDone:"Dropoff Done",
    event_CustomerFeedback:"Customer Feedback",
    event_AddPod:"Add Pod",
    event_CustomerCanceled:"Customer Canceled",
    event_DriverCanceled:"Driver Canceled",
    event_SupportCanceled:"Support Canceled",
    event_Updated:"Updated",
    event_DriverAssignment:"Driver Assignment",
    event_DriverReject:"Driver Reject",
    event_Collecting:"Collecting",
    event_InTransit:"In Transit",
    event_Delivering:"Delivering",
    event:"Event" ,
    tab_Delivery:"Delivery",
    tab_Ondemand:"On Demand",
    tab_Pickup:"Pickup",
    tab_PickupDelivery :"P&D",
    CurrentStatus:"Current Status",
    Changestatus:"Change status",
    Newstatus:"New status" ,
    Savechanges:"Save changes",
    Other:"Other" ,
    serviceCustomerError1 :"xxx isn't available for this customer." ,
    serviceCustomerError2 :" He/She only can choose xxx Service",
    serviceCustomerError3 :" He/She only can choose xxx ",
    OrderCode:"Order Code" ,

    CopyOrderlink:"Kopioi tilauslinkki" ,
    CopyPickuplink:"Kopioi pickup-linkki" ,
    CopyDeliverylink:"Kopioi Toimituslinkki"  ,
    Bulkimport:"Irrotus",
    Downloadsamplecsv:"Lataa näyte CSV",
    processing:"Jalostus" ,
    done :"Valmis" ,
    failed:"Epäonnistui",
    Draft:"Luonnos" ,
    Uploading:"Lataaminen" ,
    Draganddropyourfile:"Vedä ja pudota tiedosto",
    Onlycsvformatissupported:"Vain .csv-muotoa tuetaan" ,
    ORyoucan:"Tai voit",
    Openfile:"Avaa tiedosto" ,
    Noimportsyet:"Ei vielä tuontia" ,
    NoimportsyetDesc :"Näet tuonnin luettelon täältä ja tarkistaa tilasi",
    nosupportdialogeTitle:"Tiedostomuotoa ei tueta",
    nosupportdialogeText : "xxx-tiedostoa ei tueta.Voit ladata vain .csv-tiedoston, mukaan lukien tilaustiedot" ,
    ok:"ok" ,
    Import  :"Tuonti",
    previewTitle :"Esikatsele ja valitse Valinnat",
    previewDesc:"Tämä on tiedostojen ensimmäinen kohde tarkistaaksesi tietosi oikealla rakenteella" ,
    Upload:"Ladata", 
    Remove:"Poista" ,
    ServiceandOrdertype:"Palvelu ja tilaustyyppi" ,
    Fileisproccessing:"Tiedosto on käsittelyä ...",
    "proccessingDesc":"Voit päivittää, onko tulos valmis",
    serverError:"palvelinvirhe",
    isRequired:"xxx tarvitaan" ,
    Result:"Tulos",
    ResultText:"Näet ongelmat täältä ja ladata nämä rivit korjata erikseen",
    ErrorDetails:"Virhe",
    ErrorDetailsText:"Virheiden tilaukset on lueteltu tiedostossa, jonka voit ladata alla.Se sisältää virhetiedot kullekin riville.",
    DownloadErroredRows:"Lataa virheelliset rivit" ,
    importedsuccessfully:"xxx-tilaukset tuodaan onnistuneesti" ,
    ordershaserrors:"xxx tilauksilla on virheitä",
    refresh:"virkistää",
    CashOnDelivery:"Käteinen toimitus",
    EnterAmount:"Enter amount",
    COD:"Käteinen toimitus",
    Surchargexxx:"Lisämaksu xxx",
    AddCreditCard:"Lisää luotto- / maksukortti",
    CustomerWallet:"Asiakas lompakko ",
    Add:"Lisätä",
    Addedsuccessfully: "Lisätty onnistuneesti",
    NoRecentAddress:"Ei äskettäinen osoite",
    NoRecentAddressD:"Asiakas Viimeisimmät osoitteet luetellaan tässä",
    CustomerIsNotChoosed:"Asiakasta ei valita",
    CustomerIsNotChoosedD:"Valitse asiakas näyttämään viimeaikainen osoitteensa",
    SearchAddress:"Hakuosoite",
    NoCustomerfound: "Mitään asiakasta ei löytynyt" ,
    NoCustomerfoundD:"Voit luoda asiakkaan, jos se on uusi",
    NewCustomer : "Uusi asiakas",
    Existing:"Nykyinen",
    EmailOtional:"Sähköposti (valinnainen)" ,
    phonenumberisnotcorrect:"Puhelinnumero ei ole oikea",
    Emailisnotcorrect:"Sähköposti ei ole oikea" ,
    Registercustomer:"Rekisteröi asiakas",
    incoming:"Saapuva puhelu",
    outgoing:"lähtevä puhelu",
    recording:"nauhoituspuhelu",
    driveroperatorCallStatus:"Kuljettajan soittaja",
    customeroperatorCallStatus:"Asiakas soitti operaattori",
    newCustomeroperatorCallStatus:"Uusi asiakas soitti operaattorille",
    operatordriverCallStatus:"Operaattori soitti kuljettajalle",
    operatorcustomerCallStatus:"Operaattori soitti asiakkaalle",
    operatornewCustomerCallStatus:"Operaattori soitti uudelle asiakkaalle",
    dispatcher_Voip:"Operaattori",
    driver_Voip:"Kuljettaja",
    customer_Voip:"Asiakas",
    activeorders:"xxx aktiiviset tilaukset",
    Noactiveorder :"Ei aktiivista järjestystä" ,
    CreateOrder:"Luoda tilaus",
    call:"Soittaa puhelimella",
    spanish:"Espanja",
    es : "Espanja",
    networkError:"Ei Internet-yhteyttä",
    createdAt:"Luotu jhk",
    dueDate:"Eräpäivä",
    Noresultfound:"Tulosta ei löytynyt",
    loadMore:"Lataa lisää",
    Searchresult:"Hakutulos",
    "PinTop":"Pinsoida",
    "UnPin":"Mänty",
    "Itemsonmap":"Kohteet kartalla",
    "Orders":"Määräys",
    "Drivers":"Kuljettajat",
    "min":"xxx Min" ,
    Confirming:"Vahvistus",
    delay:"Viive",
    late:"Myöhään",
    OrderDetails:"Tilauksen tiedot",
    Profile:"Profiili",
    Waitingforavailabledrivers:"Odottaa kuljettajia saataville",
    Queue:"Jonottaa",
    OfferingToDrivers:"Tarjous xxx -ohjaimille",
    WaitforAccept:"Odota hyväksyä" ,



    todayat: 'Tänään',
    tomorrowat: 'Huomenna',
    nextWeekat: 'Ensi viikolla',
    lastDayat: 'Viimeinen päivä',
    lastWeekat: 'Viime viikolla',
    "AssignedAt":"Määritä xxx min",
    "StartedAt":"Aloita xxx min",
    "ArrivedAt":"Saavu xxx min",
    "PickedUpAt":"Nouto xxx min",
    "DoneAt":"Viimeistele xxx min",
    mindelay: 'xxxm -viive',
    minlate: 'xxxm myöhässä',
    Thereisnoorder:"Ei ole järjestystä",
    mapitems:"Kartta",
    Offerings:"Tarjoukset",
    Reject:"Hylätä",
    dropoffCustomerDescription:"Pudota muistiinpano",
    customerPhoto:"Asiakaskuva" ,
    driverPhoto:"Kuljettajan valokuva" ,
    NocustomerPhoto:"Ei asiakasvalokuvaa" ,
    NodriverPhoto:"Ei kuljettajan kuvaa",
    initial:"alkukirjain",
    notifying:"ilmoittaa",
    received:"sai",
    assigned:"osoitettu",
    rejected:"hylätty",
    canceled:"peruutettu",
    standby:"valmiina",
    terminated:"päättynyt",
    urgentTitle:"Vaihda kiireelliseen lähetykseen?",
    urgentDesc:"Mahdollistaa kiireellisesti tilaus on ensisijainen lähetys",
    urgentConfirm:"Kyllä, ota kiireellisesti käyttöön",
    urgentClose:"Ei, peruuta",
    Urgent:"Kiireellinen",
    photos :"Kuvat",
    Portuguese:"Portugalin kieli",
    Dispatchat:"Lähettää xxx",
    AutoDispatch:"Automaattinen lähetys" ,
    Manual:"Manuaalinen",
    Dispatchtime:"Lähetysaika" ,
    Later:"Myöhemmin",
    DispatchingNow:"Lähetetään nyt",
    Required:"Edellytetään" ,

    NoResultfromLocalDatabase:"Ei tulosta paikallisesta tietokannasta",
    NoResultfromLocalDatabaseD:"Tarkista se uudelleen tai kokeile toista avainsanaa",
    NoResultfromMapService:"Ei tulosta karttapalvelusta",
    SearchinMapService:"Hae karttapalvelusta" ,
    SearchinLocalDatabase:"Hae paikallisesta tietokannasta",
    Creditcardnotadded:"Luottokortti ei ole lisätty",
    OptimizeDropoffs:"Optimoida pudotukset",
    "Greek":"Kreikka",
    "el":"Kreikka",
    "ReferenceID":"Referenssitunnus",
    "EnterId":"Antaa henkilöllisyystodistus",
    "de":"Saksan kieli",
    "German":"Saksan kieli",
    "AustrianGerman":"Itävallan saksalainen",
    "Options":"Vaihtoehdot",
    "VehicleOptions":"Ajoneuvovaihtoehdot",
    "EditCustomer":"Muokkaa asiakasta",
    "NoDriverfound":"Ei kuljettajaa",
    "NoDriverfoundDesc":"Tarkista tietosi ja kokeile jotain muuta",
    "ClearField":"Selkeä kenttä",
    "Map":"Map",
    "Local":"Local",
    "CompleteRequiredFeileds":"Täytä vaadittavat kentät",
    "Senderinfo":"Lähettäjätiedot",
    "SchedulePickup(Optional)":"Aikataulu (valinnainen)",
    "ScheduleDelivery(Optional)": "Schedule Delivery (Optional)",

    "AddDropoff":"Lisää pudotus",
    "EditPrice":"Muokkaushinta",
    "Promotion":"Edistäminen",
    "tax":"Verottaa",
    "surcharge":"Lisämaksu xxx",
    "Receiverinfo":"Vastaanotintiedot",
    "tryagain":"Something went wrong, please try again",



    "Selected date and time":"Selected date and time",
    "Reorder stops":"Reorder stops",
    "Bulk Edit Status Summary":"Bulk Edit Status Summary",
    "Successful":"Successful",
    "Failed":"Failed",
    "Order ID":"Order ID",
    "Details":"Details",
    "Result":"Result",
    "Pickup Routed":"Pickup Routed",
    "Delivery Routed":"Delivery Routed",
    "Ref. xxx":"Ref. xxx",
    "Zone":"Zone",
    "Clear":"Clear",
    "Apply":"Apply",
    "No result found":"No result found",
    "Type your keyword":"Type your keyword",
    "Type in the input to start search":"Type in the input to start search",
    "We are sorry ...":"We are sorry ...",
    "The page you are trying to access has restricted access.":"The page you are trying to access has restricted access.",
    "Please refer to your system administrator.":"Please refer to your system administrator.",
    "Failed":"Failed",
    "Done": "Done",
    "Schedule":"Schedule",
    "Proof of delivery":"Proof of delivery",
    "Signature":"Signature",
    "Driver Photo":"Driver Photo",
    "Notes":"Notes",
    "Order Info":"Order Info",
    "Order":"Order",
    "Price":"Price",
    "P_HUB_D Orders":'P_HUB_D Orders',
    "Routes":"Routes",
    "Default pickup":"Default pickup",
    'More':'More',
    'Route name':'Route name',
    'Driver':'Driver',
    'Pickup Orders':'Pickup Orders',
    'Delivery Orders':'Delivery Orders',
    'Ready For Pickup':'Ready For Pickup',
    'PricingAndEarning':"Pricing & Earning",
    "Pricing" : "Pricing",
    "save":"Save",
    "Learn":"Learn",
    "Scheduleoverlap":"The Schedule Pickup time must be before the Schedule Delivery time and have no overlap",
    "PleaseSelectCustomer":"Please select customer",
    "NoRegisteredCustomer":"No registered customer",
    "CreateAtLeastOneCustomerToCreateOrder":"Create at least one customer to create order",
    Pinned: 'Pinned',
    Delayed: 'Delayed',
    Canceled: 'Canceled',
    InProgress: 'InProgress',
    DispatchLater: 'DispatchLater',
    Table: 'Table',
    'Clear All': 'Clear All',
    'Config Table': 'Config Table',
    'Active Columns': 'Active Columns',
    'Due time': 'Due time',
    'Search route name': 'Search route name',
    'Add Route': 'Add Route',
    'Route info': 'Route info',
    'Start Location': 'Start Location',
    'End Location ( Optional )': 'End Location ( Optional )',
    'Load Deliveries:': 'Load Deliveries:',
    No: 'No',
    Optional: 'Optional',
    Force: 'Force',
    'Code, Name, Family, Phone number': 'Code, Name, Family, Phone number',
    'Edit Route Status & Driver': 'Edit Route Status & Driver',
    'No, Cancel': 'No, Cancel',
    'Yes, Optimize': 'Yes, Optimize',
    'Optimize Stops?': 'Optimize Stops?',
    'The sequence of stops changes automatically. you can change it manually later': 'The sequence of stops changes automatically. you can change it manually later',
    'Error in loading data': 'Error in loading data',
    'There was a problem loading data. please try again or contact support': 'There was a problem loading data. please try again or contact support',
    'Try again': 'Try again',
    'Duration:': 'Duration:',
    'Edit Route info': 'Edit Route info',
    'Edit Status & Driver': 'Edit Status & Driver',
    'Reorder Stops': 'Reorder Stops',
    Optimize: 'Optimize',
    'Search stops': 'Search stops',
    'Delivery:': 'Delivery:',
    'Pickup:': 'Pickup:',
    'No Stop was found': 'No Stop was found',
    'Please check it again or try another keyword': 'Please check it again or try another keyword',
    'Add your orders': 'Add your orders',
    'You can add orders from orders pages': 'You can add orders from orders pages',
    'Go to Orders': 'Go to Orders',
    'On Demand': 'On Demand',
    P_Hub_D: 'P_Hub_D',
    Notifications: 'Notifications',
    'Admin Center': 'Admin Center',
    'Sort by': 'Sort by',
    'Sort type': 'Sort type',
    OrderType: 'OrderType',
    Stage: 'Stage',
    Status: 'Status',
    Route: 'Route',
    CreatedAt: 'CreatedAt',
    StatusUpdatedAt: 'StatusUpdatedAt',
    Note: 'Note',
    'Delivery Last Attempt Reason': 'Delivery Last Attempt Reason',
    'Delivery Attempts Count': 'Delivery Attempts Count',
    'Pickup Failed Reason': 'Pickup Failed Reason',
    ReferenceId: 'ReferenceId',
    PickupAddress: 'PickupAddress',
    DeliveryAddress: 'DeliveryAddress',
    'Driver Name': 'Driver Name',
    'Driver Phone': 'Driver Phone',
    'Customer Name': 'Customer Name',
    'Customer Phone': 'Customer Phone',
    EstimatedDistanceInMeters: 'EstimatedDistanceInMeters',
    EstimatedDuration: 'EstimatedDuration',
    'Payment Method': 'Payment Method',
    PickupAddressDetail: 'PickupAddressDetail',
    PickupCompleteAfter: 'PickupCompleteAfter',
    PickupcompleteBefore: 'PickupcompleteBefore',
    PickupFullName: 'PickupFullName',
    PickupPhone: 'PickupPhone',
    PickupEmail: 'PickupEmail',
    PickupPodNote: 'PickupPodNote',
    PickupPodPhoto: 'PickupPodPhoto',
    PickupPodSignature: 'PickupPodSignature',
    PickupZone: 'PickupZone',
    DeliveryAddressDetail: 'DeliveryAddressDetail',
    DeliveryCompleteAfter: 'DeliveryCompleteAfter',
    DeliverycompleteBefore: 'DeliverycompleteBefore',
    DeliveryFullName: 'DeliveryFullName',
    DeliveryPhone: 'DeliveryPhone',
    DeliveryEmail: 'DeliveryEmail',
    DeliveryPodNote: 'DeliveryPodNote',
    DeliveryPodPhoto: 'DeliveryPodPhoto',
    DeliveryPodSignature: 'DeliveryPodSignature',
    DeliveryZone: 'DeliveryZone',
    'Driver Vehicle': 'Driver Vehicle',
    'Driver Username': 'Driver Username',
    CustomerType: 'CustomerType',
    'Customer Email': 'Customer Email',
    PaymentProvider: 'PaymentProvider',
    Source: 'Source',
    'Shipment Label': 'Shipment Label',
    'Track Order': 'Track Order',
    'Create your first order':'Create your first order',
    'Your orders will be shown here in table with full details and actions':'Your orders will be shown here in table with full details and actions' ,
    'Please check your filters or keyword' : 'Please check your filters or keyword' ,
    'from' : "from",
    'rows' :"rows" , 
    "Prev" :"Prev" ,
    "Next" :"Next"
};